module.exports = __webpack_public_path__ + "static/media/Exclamation_Icon@3x.ac6bdb02.png";